"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/toConsumableArray.js
 ** module id = 311
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/toConsumableArray.js
 ** module id = 311
 ** module chunks = 1
 **/